import { render, staticRenderFns } from "./PassengersListModal.vue?vue&type=template&id=52fc0a90&"
import script from "./PassengersListModal.vue?vue&type=script&lang=js&"
export * from "./PassengersListModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports